export class SC_Client {
    /**
     * Input property name constants for fromAPI
     */
    static inputKeys = {
        id: 'id',
        name: 'name',
        abbreviation: 'abb',
        see_qc_tech_count: 'see'
    };

    internalID: number | null;
    name: string | null;
    abbreviation: string | null;
    see_qc_tech_count: boolean | null;

    constructor({
                id = null,
                name = null,
                abbreviation = null,
                see_qc_tech_count = null
            } = {}) {
        this.internalID = id;
        this.name = name;
        this.abbreviation = abbreviation;
        this.see_qc_tech_count = see_qc_tech_count;
    }

    static fromAPI(jsonin: Record<string, unknown>): SC_Client {
        return new SC_Client({
            id: jsonin[SC_Client.inputKeys.id] ?? null,
            name: jsonin[SC_Client.inputKeys.name] ?? null,
            abbreviation: jsonin[SC_Client.inputKeys.abbreviation] ?? null,
            see_qc_tech_count: jsonin[SC_Client.inputKeys.see_qc_tech_count] ?? null
        });
    }

    toAPI(): Record<string, unknown> {
        return {
            [SC_Client.inputKeys.id]: this.internalID,
            [SC_Client.inputKeys.name]: this.name,
            [SC_Client.inputKeys.abbreviation]: this.abbreviation,
            [SC_Client.inputKeys.see_qc_tech_count]: this.see_qc_tech_count
        };
    }

    clone(): SC_Client {
        const cloned = new SC_Client();

        cloned.internalID = this.internalID;
        cloned.name = this.name;
        cloned.abbreviation = this.abbreviation;
        cloned.see_qc_tech_count = this.see_qc_tech_count;

        return cloned;
    }

    /**
     * Merges another SC_Client object into this one, replacing null fields
     */
    merge(other: SC_Client): SC_Client {
        if (other.internalID !== null) this.internalID = other.internalID;
        if (other.name !== null) this.name = other.name;
        if (other.abbreviation !== null) this.abbreviation = other.abbreviation;
        if (other.see_qc_tech_count !== null) this.see_qc_tech_count = other.see_qc_tech_count;

        return this;
    }
}
